import PrivateClassTrackDao from '../dao/private-class-track.dao';
import type {
  PrivateClassCategoryTracks,
  PrivateClassTrackCategory,
} from '../interfaces';
import type { Environment } from '../interfaces/environment';
import type {
  PrivateClassTrack,
  PrivateClassTrackServer,
} from '../interfaces/private-class-track';
import { hostsConfig } from '../utils';
import type { PrivateClassTrackCategoryServer } from './../interfaces/private-class-track-category';

export abstract class PrivateClassTrackService {
  private static fillTrackData(
    track: PrivateClassTrackServer,
    oeContentUrl: string
  ): PrivateClassTrack {
    return {
      ...track,
      levelLabelKey: `pc_revamp.${track.level.uuid}.label`,
      titleKey: `pc_revamp.${track.uuid}.name`,
      descriptionKey: `pc_revamp.${track.uuid}.description`,
      image: `${oeContentUrl}/production/private-classes/assets/images/${track.uuid}.jpg`,
    };
  }

  private static fillTrackCategory(
    category: PrivateClassTrackCategoryServer
  ): PrivateClassTrackCategory {
    return {
      ...category,
      titleKey: `pc_revamp.${category.uuid}.name`,
      descriptionKey: `pc_revamp.${category.uuid}.description`,
    };
  }

  static async getSelectedPrivateClassTrack(
    env: Environment,
    contactId: string
  ): Promise<PrivateClassTrack> {
    const { oeContentUrl } = hostsConfig[env];
    const track = await PrivateClassTrackDao.getSelectedPrivateClassTrack(
      env,
      contactId
    );

    return this.fillTrackData(track, oeContentUrl);
  }

  static setSelectPrivateClassTrack(
    env: Environment,
    contactId: string,
    lessonTrackUuid: string
  ): Promise<void> {
    return PrivateClassTrackDao.selectPrivateClassTrack(
      env,
      contactId,
      lessonTrackUuid
    );
  }

  static async getPrivateClassTrackCategories(
    env: Environment
  ): Promise<PrivateClassTrackCategory[]> {
    const categories =
      await PrivateClassTrackDao.getPrivateClassTrackCategories(env);

    return categories.map(this.fillTrackCategory);
  }

  static async getPrivateClassTrackByCategory(
    env: Environment,
    contactId: string,
    category: PrivateClassTrackCategory
  ): Promise<PrivateClassCategoryTracks> {
    const { oeContentUrl } = hostsConfig[env];
    const tracks = await PrivateClassTrackDao.getPrivateClassTrackByCategory(
      env,
      contactId,
      category.uuid
    );

    return {
      ...category,
      tracks: tracks
        .filter(({ active }) => active)
        .map<PrivateClassTrack>((track) =>
          this.fillTrackData(track, oeContentUrl)
        ),
    };
  }
}
